import { useLanguage } from "@/lib/i18n";
import { translations } from "@/lib/translations";
import { DEMO_POSTER_SRC, DEMO_VIDEO_SRC } from "./demo-seo-data";

/**
 * The vertical (1080x1920) demo clip, centred and sized to the space left by
 * the title and the store badges, so the whole page fits on a laptop screen
 * without scrolling. Autoplays muted and loops; `playsInline` keeps it inline
 * on iPhone instead of taking over the screen.
 */
export function DemoVideo() {
  const { language } = useLanguage();
  const t = translations[language].demo;

  return (
    <div className="relative flex h-full min-h-0 w-full items-center justify-center">
      <div className="relative h-full min-h-0">
        {/* Soft glow behind the phone-shaped frame */}
        <div
          className="pointer-events-none absolute -inset-5 rounded-[2.5rem] bg-primary/10 blur-3xl"
          aria-hidden="true"
        />
        <video
          // The max-height is a hard cap: never taller than the space left by
          // the title and the store badges (which wrap onto two rows on a
          // phone), so the page never needs scrolling to see the whole demo.
          className="relative z-10 h-full w-auto max-w-full rounded-3xl border border-border/60 bg-secondary object-contain shadow-2xl shadow-primary/10 max-h-[calc(100svh-30rem)] sm:max-h-[min(620px,calc(100svh-27rem))]"
          src={DEMO_VIDEO_SRC}
          poster={DEMO_POSTER_SRC}
          controls
          autoPlay
          loop
          muted
          playsInline
          preload="metadata"
          aria-label={t.videoLabel}
        >
          {t.videoFallback}
        </video>
      </div>
    </div>
  );
}
